import React from 'react';
import { NCZICompositionItem } from '../../../../Interfaces/ncziTypes';
import EHRCompositionItemAsList from './EHRCompositionItemAsList';
import EHRNoItemsFound from '../../EHRNoItemsFound';

interface Props {
	items: NCZICompositionItem[] | undefined;
	patientIdentifier: string;
	onCloseDetail?: (needReload: boolean) => void;
}

const EHRCompositionItemsAsList: React.FC<Props> = props => {
	const { items, patientIdentifier, onCloseDetail } = props;

	if (!items || !items.length) {
		return (
			<>
				<EHRNoItemsFound />
			</>
		);
	}

	return (
		<>
			{items.map((item, key) => (
				<EHRCompositionItemAsList
					key={key}
					item={item}
					patientIdentifier={patientIdentifier}
					onCloseDetail={onCloseDetail}
				/>
			))}
		</>
	);
};

export default EHRCompositionItemsAsList;
